import { useFetch } from './useFetch';
import type { AsyncState } from './useFetch';
import { fetchUserGrants, fetchUsers } from '@/api/users';
import type { UsersQuery } from '@/api/users';
import type { UserGrantsResponse, UsersResponse } from '@/api/types';

export function useUsers(query: UsersQuery = {}): AsyncState<UsersResponse> {
  const key = JSON.stringify(query);
  return useFetch<UsersResponse>((signal) => fetchUsers(query, signal), [key]);
}

export function useUserGrants(email: string | undefined): AsyncState<UserGrantsResponse> {
  return useFetch<UserGrantsResponse>(
    (signal) => fetchUserGrants(email!, signal),
    [email ?? ''],
    { enabled: !!email },
  );
}
